var map = {
	"./firstshuaige.mp3": "7c4b",
	"./start.mp3": "3950",
	"./start_new.mp3": "3e39",
	"./start_page1.mp3": "92f5",
	"./start_page10.mp3": "174f",
	"./start_page11.mp3": "26ef",
	"./start_page2.mp3": "e274",
	"./start_page22.mp3": "cbb3",
	"./start_page3.mp3": "84d2",
	"./start_page4.mp3": "3326",
	"./start_page5.mp3": "36e8",
	"./start_page6.mp3": "ac5e",
	"./start_page7.mp3": "3f7b",
	"./一起走出去.mp3": "2640",
	"./先请帅哥填写自己的姓名电话等内容1.mp3": "0375",
	"./先请帅哥填写自己的姓名电话等内容2.mp3": "d894",
	"./加油.mp3": "21d0",
	"./吐舌.mp3": "1ecb",
	"./呵呵.mp3": "d427",
	"./哈哈.mp3": "621ac",
	"./囧囧.mp3": "9211",
	"./安慰.mp3": "2d43",
	"./开心.mp3": "fe93",
	"./心疼.mp3": "175e",
	"./恭喜你们游戏结束了.mp3": "8e64",
	"./惊讶.mp3": "4ae7",
	"./感动.mp3": "372e",
	"./感激.mp3": "d1e3",
	"./抱抱.mp3": "3782",
	"./担心.mp3": "6669",
	"./无语.mp3": "47bf",
	"./此时两人不要说话.mp3": "8926",
	"./流泪.mp3": "4d1f",
	"./满意.mp3": "724b",
	"./点赞.mp3": "ba2f",
	"./理解.mp3": "6569",
	"./膜拜.mp3": "f8a8",
	"./请帅哥向美女分享一个自己的私人困扰或烦恼.mp3": "2e25",
	"./请帅哥填写.mp3": "e9f6",
	"./请帅哥拍照.mp3": "ff4f",
	"./请帅哥换位思考.mp3": "6318",
	"./请帅哥换位思考1.mp3": "3f6a",
	"./请帅哥换位思考2.mp3": "94e3",
	"./请帅哥点击一个听后感想.mp3": "7498",
	"./请美女向帅哥分享一个自己的私人困扰或烦恼.mp3": "fa67",
	"./请美女填写.mp3": "cc8b",
	"./请美女填写1.mp3": "f8fe",
	"./请美女拍照.mp3": "309e",
	"./请美女换位思考.mp3": "1cbd",
	"./请美女换位思考1.mp3": "ef18",
	"./请美女换位思考2.mp3": "da4a",
	"./请美女点击一个听后感想.mp3": "9d33",
	"./赞同.mp3": "8232",
	"./赞许.mp3": "ca4b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba5b";